module.exports = __webpack_public_path__ + "img/hamburger-icon-white.659ebc26.svg";